import cn from 'classnames'
import React, { ComponentProps } from 'react'

type UploadCloudIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function UploadCloudIcon(props: UploadCloudIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('UploadCloudIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.66659 10.8282C1.86259 10.29 1.33325 9.37347 1.33325 8.33333C1.33325 6.77095 2.52759 5.48753 4.05308 5.34625C4.36513 3.44809 6.01341 2 7.99992 2C9.98642 2 11.6347 3.44809 11.9468 5.34625C13.4722 5.48753 14.6666 6.77095 14.6666 8.33333C14.6666 9.37347 14.1372 10.29 13.3333 10.8282M5.33325 10.6667L7.99992 8M7.99992 8L10.6666 10.6667M7.99992 8V14"
        stroke="#4489F9"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
